import { InjectionToken } from '@angular/core';

import { CURRENT_HOST_ID } from './current-host-id';
import type { CurrentHost } from './current-host.interface';
import { HostId } from './host-id.enum';

/**
 * Information about the current host.
 *
 * Usage:
 *
 * ```ts
 * class WhateverThing {
 *  public constructor(
 *    @Inject(currentHostRef) private readonly currentHost: CurrentHost
 *  ) { }
 * ```
 *
 * Mocking in Tests:
 *
 * ``` ts
 * beforeEach(() => {
 *   TestBed.configureTestingModule({
 *     providers: [
 *       MockProvider(currentHostRef, { ... })
 *     ]
 *   });
 * });
 * ```
 */
export const currentHostRef = new InjectionToken<CurrentHost>('CURRENT_HOST', {
  providedIn: 'root',
  factory: () => ({
    id: CURRENT_HOST_ID,
    isProdLike: [HostId.Prod, HostId.PreProd].includes(CURRENT_HOST_ID),
    isUnknown: CURRENT_HOST_ID === HostId.Unknown,
    isLocal: CURRENT_HOST_ID === HostId.Local,
    isDev: CURRENT_HOST_ID === HostId.Dev,
    isTest: CURRENT_HOST_ID === HostId.Test,
    isInt: CURRENT_HOST_ID === HostId.Int,
    isPreProd: CURRENT_HOST_ID === HostId.PreProd,
    isProd: CURRENT_HOST_ID === HostId.Prod
  })
});
